export const promoActive = true;

export const promoData = {
  discountPercent: 40,
  plansOnPromo: ["Starter", "Avancé", "Expert"], // Noms exacts dans tier.title
};
